module.exports = __webpack_public_path__ + "img/offer.4746c5e5.png";